<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>
                <v-icon
                    style="position: relative; top: -1px; margin-right: 2px;"
                    v-on:click="closeDialog"
                >
                    mdi-arrow-left
                </v-icon>
                {{title}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="closeDialog"
                >
                    Cancel
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <m-select-employee-endpoint
                v-if="dialog"
                :selected_endpoint="selected_endpoint"
                v-on:select="onSelectEndpoint"
                :organization_id="organization_id"
            />

        </v-card-text>

    </v-card>

    
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {

    props: {
        'title': {
            type: String,
            default: function() { return 'Switch Phone Number'; }
        },

        'selected_endpoint': {
            type: String,
            default: function() { return null; }
        },

        'organization_id': {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
           
            // data is valid, so save 
            this.closeDialog();
            next(false);
        },

        onSelectEndpoint(item)
        {
            this.closeDialog();
            this.$emit('select-endpoint', item.endpoint);
        },
    },

    
}
</script>

<style lang="scss" scoped>



</style>